import axios from "axios";

// const API_URL = "http://127.0.0.1:8000";
const API_URL = "https://std-manage-backend-production.up.railway.app";


export const getStudents = () => axios.get(`${API_URL}/students`);
export const createStudent = (student) => axios.post(`${API_URL}/students`, student);
export const getStudentById = (id) => axios.get(`${API_URL}/students/${id}`);
export const updateStudent = (id, student) => axios.put(`${API_URL}/students/${id}`, student);
export const deleteStudent = (id) => axios.delete(`${API_URL}/students/${id}`);
